import PluginHeaderContent from 'component/layout/PluginHeaderContent';
import { observer, useLocalObservable } from 'mobx-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRootStore } from 'store/StoreContextProvider';
import TaskGradeEditBody from '../EmployeeDetailPage/component/TaskGradeEditBody';
import TaskGradeEditBodyEssential from '../EmployeeDetailPage/component/TaskGradeEditBodyEssential';
import TaskGradeEditBodyEssentialModal from '../EmployeeDetailPage/component/TaskGradeEditBodyEssentialModal';
import TaskGradeEditBodyScore from '../EmployeeDetailPage/component/TaskGradeEditBodyScore';
import TaskGradeEditBottom from './component/TaskGradeEditBottom';
import TaskGradeEditHeader from '../EmployeeDetailPage/component/TaskGradeEditHeader';
import TaskGradeEditPageStore from '../EmployeeDetailPage/store/TaskGradeEditStore';
import { useFormik } from 'formik';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import bluePin from '../../assets/image/bluePin.png';
import redPin from '../../assets/image/redPin.png';
import bluePinEmpty from '../../assets/image/bluePinEmpty.png';
import redPinEmpty from '../../assets/image/redPinEmpty.png';

import { CircularProgress, Grid, IconButton, Snackbar } from '@mui/material';
import useSnackbarMessage from 'shared/snackbar';
import { toJS } from 'mobx';
import CheckModal from '../EmployeeDetailPage/component/CheckModal';
import { AssessModel } from 'domains/models/AssessModel';
import { useMediaQueryState } from '../../hooks/useMediaQueryState';
import { Dialog } from 'antd-mobile';

function TaskGradingEditInvisiblePage() {
  const { loginStore, headerStore } = useRootStore();
  const snackbar = useSnackbarMessage();
  const pageStore = useLocalObservable(() => new TaskGradeEditPageStore());
  const location = useLocation();
  const [updateMode, setUpdateMode] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const { isMobile, isOutlook } = useMediaQueryState();
  const [fillBlueIcon, setFillBlueIcon] = React.useState<boolean>(false);
  const [fillRedIcon, setFillRedIcon] = React.useState<boolean>(false);
  const formik = useFormik({
    initialValues: {
      grade: location.state.assess?.userData?.grade ? location.state.assess?.userData?.grade : 0,
      message: location.state.assess?.userData?.message ? location.state.assess?.userData?.message : '',
      emoticon: 0,
    },
    // enableReinitialize: true,
    // validationSchema: yup.object({
    //   message: yup.number().min(1, '5자 이상입력해주세요').required('필수입력값 입니다.'),
    // }),
    onSubmit: async (values: any) => {
      console.log('SUBMIT', values, pageStore.score, pageStore.task);
      console.log(pageStore.task!.userData);

      if (pageStore.score === '0') {
        Dialog.alert({
          content: '평가 점수는 필수 항목입니다.',
          confirmText: '확인',
        });
        //alert("평가 점수는 필수 항목입니다.");
        return;
      }
      if (pageStore.score !== '0') {
        values.grade = pageStore.score;
      }

      pageStore.allSave();

      let like = '';
      if (fillBlueIcon) {
        like = 'true';
      }
      if (fillRedIcon) {
        like = 'false';
      }
      try {
        if (updateMode) {
          await pageStore.updateAssess(values, like, loginStore.currentUser!);
          console.log(pageStore.task);

          // 공개평가이면서, 비공개평가를 안한 경우
          if (!pageStore.task!.userData?.pubDoneIdList?.includes(loginStore.currentUser!.id)) {
            pageStore.setIsOpenModal(true);
            return;
          }

          navigate('/plugin/mails' + location.search, {
            state: { employee: toJS(pageStore.employee) },
          });
        } else {
          await pageStore.createTaskAssess(values, like, loginStore.currentUser!, 'INVISIBLE', headerStore.isDoneAssess);
          if (pageStore.task!.userData?.pubDoneIdList?.includes(loginStore.currentUser!.id)) {
            navigate('/plugin/mails' + location.search, {
              state: { employee: toJS(pageStore.employee) },
            });
            return;
          }

          console.log(pageStore.employee);
          if (headerStore.isDoneAssess) {
            navigate('/plugin/mails' + location.search, {
              state: { employee: toJS(pageStore.employee), isAssessDone: true },
            });
          } else {
            headerStore.setIsDoneAssess(true);
            pageStore.setIsOpenModal(true);
          }
        }
      } catch (err: any) {
        snackbar.error(err.message);
      }
    },
  });

  const handleClose = () => {
    pageStore.setSubmitted(false);
  };

  const handleClickBlueIcon = () => {
    if (fillRedIcon) {
      setFillRedIcon(false);
    }
    setFillBlueIcon(!fillBlueIcon);
  };

  const handleClickRedIcon = () => {
    if (fillBlueIcon) {
      setFillBlueIcon(false);
    }
    setFillRedIcon(!fillRedIcon);
  };

  useEffect(() => {
    if (location.state.task && location.state.employee) {
      const task = location.state.task;
      console.log(location.state);
      if (location.state.assess) {
        const assess = location.state.assess;
        pageStore.setAssess(assess);
        setUpdateMode(true);
        fetchQuestionAllList(assess);
        if (assess.userData?.like) {
          if (assess.userData?.like === 'true') {
            setFillBlueIcon(true);
          } else {
            setFillRedIcon(true);
          }
        }
      } else {
        fetchQuestionList();
      }

      pageStore.setTask(task);
      pageStore.setEmployee(location.state.employee);
      console.log('TASK', task, formik);
      pageStore.setFormik(formik);
    }
  }, []);

  const fetchQuestionList = async () => {
    try {
      await pageStore.fetchQuestionList();
      console.log('fetchQuestionList#1');
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  const fetchQuestionAllList = async (assess: AssessModel) => {
    try {
      await pageStore.fetchQuestionAllList(assess);
    } catch (err: any) {
      snackbar.error(err.message);
    }
  };

  const onClickOpenOk = () => {
    navigate('/employee-detail/open', {
      state: {
        employee: toJS(pageStore.employee),
        task: toJS(pageStore.task),
      },
    });
  };

  const handleClickCancelModal = () => {
    navigate('/plugin/mails' + location.search, {
      state: { employee: toJS(pageStore.employee) },
    });
    pageStore.setIsOpenModal(false);
  };

  return (
    <PluginHeaderContent>
      <TaskGradeEditHeader title={'PAS - Closed Assessment'} />
      <Grid style={isMobile ? (isOutlook ? { position: 'absolute', right: 20, top: 25, cursor: 'pointer' } : { position: 'absolute', right: 60, top: 60, cursor: 'pointer' }) : { position: 'absolute', right: 50, top: 0, cursor: 'pointer' }}>
        {fillBlueIcon ? <img src={bluePin} onClick={handleClickBlueIcon} alt='bluePin' /> : <img src={bluePinEmpty} onClick={handleClickBlueIcon} alt='bluePinEmpty' />}
        {fillRedIcon ? (
          <img
            src={redPin}
            style={{
              marginLeft: '15px',
              cursor: 'pointer',
            }}
            onClick={handleClickRedIcon}
            alt='redPin'
          />
        ) : (
          <img
            src={redPinEmpty}
            style={{
              marginLeft: '15px',
              cursor: 'pointer',
            }}
            onClick={handleClickRedIcon}
            alt='redPinEmpty'
          />
        )}
      </Grid>
      <Grid style={{ padding: '20px 10px 100px 10px' }}>
        {pageStore.isLoading ? (
          <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
            <CircularProgress />
          </Grid>
        ) : (
          pageStore.formik && (
            <form onSubmit={pageStore.formik.handleSubmit}>
              <TaskGradeEditBody pageStore={pageStore} isOpenAssess={false} />
              <TaskGradeEditBodyScore pageStore={pageStore} />
              <TaskGradeEditBodyEssential updateMode={updateMode} pageStore={pageStore} />
              <TaskGradeEditBottom pageStore={pageStore} />
            </form>
          )
        )}
      </Grid>

      <CheckModal
        isOpen={pageStore.isOpenModal}
        handleClose={() => pageStore.setIsOpenModal(false)}
        title='공개 평가를 작성하러 가시겠습니까?'
        content='*향후 Done 항목에서 추가 평가는 가능합니다.'
        onClickOk={onClickOpenOk}
        onClickCancel={handleClickCancelModal}
      />
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={pageStore.submitted}
        autoHideDuration={2000}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        onClose={handleClose}
        message={'Your summary has been sent.'}
        action={[
          <IconButton key='close' onClick={handleClose}>
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </PluginHeaderContent>
  );
}

export default observer(TaskGradingEditInvisiblePage);
